import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Checkbox
} from '@mui/material';
import { MSN } from './msnTheme';

export default function CreateGroupModal({ open, onClose, contacts, onCreateGroup }) {
  const [name, setName] = useState('');
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleToggle = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSubmit = async () => {
    const nameTrim = (name || '').trim();
    if (!nameTrim) {
      setError('Informe o nome do grupo.');
      return;
    }
    if (selectedIds.length === 0) {
      setError('Selecione ao menos um participante.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const conv = await onCreateGroup(nameTrim, selectedIds);
      if (conv) {
        onClose();
        setName('');
        setSelectedIds([]);
        return conv;
      }
      setError('Não foi possível criar o grupo.');
    } catch (e) {
      setError(e?.message || 'Erro ao criar grupo.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setName('');
    setSelectedIds([]);
    setError('');
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: MSN.windowBg,
          border: `2px solid ${MSN.border}`,
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
        }
      }}
    >
      <DialogTitle
        component="div"
        sx={{
          background: MSN.titleBar,
          color: MSN.titleBarText,
          fontWeight: 700,
          fontSize: 14,
          borderBottom: `1px solid ${MSN.border}`
        }}
      >
        Novo grupo
      </DialogTitle>
      <DialogContent sx={{ bgcolor: MSN.contentBg, pt: 2 }}>
        <TextField
          fullWidth
          label="Nome do grupo"
          value={name}
          onChange={(e) => setName(e.target.value)}
          sx={{
            mb: 2,
            '& .MuiOutlinedInput-root': { bgcolor: MSN.inputBg },
            '& .MuiInputLabel-root': { color: MSN.textSecondary }
          }}
        />
        <Typography variant="subtitle2" sx={{ color: MSN.textSecondary, mb: 1, fontSize: 12 }}>
          Participantes
        </Typography>
        <Box sx={{ maxHeight: 240, overflow: 'auto', border: `1px solid ${MSN.border}`, borderRadius: 1, bgcolor: MSN.windowBg }}>
          <List dense>
            {(contacts || []).map((c) => (
              <ListItem key={c.id} disablePadding>
                <ListItemButton onClick={() => handleToggle(c.id)} dense sx={{ '&:hover': { bgcolor: MSN.hoverBg } }}>
                  <Checkbox edge="start" checked={selectedIds.includes(c.id)} sx={{ color: MSN.buttonBg }} />
                  <ListItemText primary={c.nome || c.email} secondary={c.email} primaryTypographyProps={{ fontSize: 13 }} secondaryTypographyProps={{ fontSize: 11 }} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
        {error && (
          <Typography variant="body2" color="error" sx={{ mt: 1, fontSize: 12 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, pt: 1, bgcolor: MSN.contentBg, borderTop: `1px solid ${MSN.border}` }}>
        <Button onClick={handleClose} sx={{ color: MSN.textSecondary }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading}
          sx={{
            background: MSN.sendButton,
            color: '#fff',
            '&:hover': { background: MSN.sendButtonHover }
          }}
        >
          {loading ? 'Criando...' : 'Criar grupo'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
